import { UserInfo, Contact } from '../models/interfaces';

interface FetchUserInfoAction {
  type: ActionTypes.fetchUserInfo;
  payload: UserInfo;
}

interface ToggleSymptomAction {
  type: ActionTypes.toggleSymptom;
  payload: { [symptomName: string]: boolean };
}

interface AddNewContact {
  type: ActionTypes.addNewContact;
  payload: Contact;
}

interface DeleteContact {
  type: ActionTypes.deleteContact;
  payload: string;
}

export enum ActionTypes {
  fetchUserInfo,
  toggleSymptom,
  addNewContact,
  deleteContact,
}

export type Action = FetchUserInfoAction | ToggleSymptomAction | AddNewContact | DeleteContact;
